var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTop = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#5C5F62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69472 5.38574L15.6155 5.38574C15.9983 5.38574 16.3086 5.07545 16.3086 4.69269C16.3086 4.30992 15.9983 3.99963 15.6155 3.99963L4.69472 3.99963C4.31216 3.99963 4.00167 4.31012 4.00167 4.69269C4.00167 5.07525 4.31216 5.38574 4.69472 5.38574Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.82852L9.5 16.6338C9.5 17.048 9.83579 17.3838 10.25 17.3838C10.6642 17.3838 11 17.048 11 16.6338L11 9.82852L13.25 9.82852L10.25 6.83602L7.25 9.82852L9.5 9.82852Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/top.c98f8994.svg";
export { ForwardRef as ReactComponent };